import { render, staticRenderFns } from "./main_resident.vue?vue&type=template&id=8f276c00&scoped=true"
import script from "./main_resident.vue?vue&type=script&lang=js"
export * from "./main_resident.vue?vue&type=script&lang=js"
import style0 from "./main_resident.vue?vue&type=style&index=0&id=8f276c00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f276c00",
  null
  
)

export default component.exports